import { useContext, useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Body, TopBar, LeftNav, BottomNav } from "../layout";
import ReactErrorFallback from "../error-handling/ReactErrorFallback";
import { useGoogleTranslateErrorHandler } from "../error-handling/GoogleTranslateErrorHandler";
import AppContext from "../../state/AppContext";
import { PoweredByKorero } from "./PoweredByKorero";
import ImpersonationBanner from "../common/ImpersonationBanner";

function StandardLayout() {
  const appContext = useContext(AppContext);
  const [hasErrored, setHasErrored] = useState(false);

  // Hook for Google Translate error detection
  const { handleError, showTranslateWarning, TranslateWarningModal } =
    useGoogleTranslateErrorHandler();

  useEffect(() => {
    // When the side bar is open we need to add the class to the body to allow for the Accessibe trigger
    // to be hidden... because there are scenarios where this overlaps key functionality (like a button)
    // and the user is unable to interact with the feature as intended.
    if (appContext.sideBarIsOpen) {
      document.body.classList.add("sidebar-opened");
    } else {
      document.body.classList.remove("sidebar-opened");
    }
  }, [appContext.sideBarIsOpen]);

  return (
    <div className="relative min-h-screen max-h-screen flex overscroll-contain overflow-hidden print:overflow-visible print:max-h-none">
      <LeftNav />

      {/* min-w-0 stops over-wide content (e.g. a wide table) from growing this
          flex item past the viewport, where the shell's overflow-hidden would
          clip it with no way to scroll. */}
      <div className="flex flex-col w-full min-w-0">
        <TopBar />
        <ImpersonationBanner />
        <ErrorBoundary
          FallbackComponent={
            showTranslateWarning ? () => null : ReactErrorFallback
          }
          resetKeys={[hasErrored]}
          onReset={() => {
            // reset the state of your app so the error doesn't happen again
            setHasErrored(false);
            window.console.error("Reset state, error happened");
          }}
          onError={handleError}
        >
          <Body />
        </ErrorBoundary>
      </div>
      <BottomNav />

      {/* Google Translate Warning Modal */}
      <TranslateWarningModal isOpen={showTranslateWarning} />
    </div>
  );
}

export default StandardLayout;
